import type { Observable as ObservableType } from 'rxjs/Observable';
import type { StatusCategoryKeys } from '@atlassian/jira-common-constants/src/status-categories';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { BacklogStrategy } from '../../model/types';

export type BoardConfigResponse = {
	name: string;
	backlogStrategy: BacklogStrategy;
	isBoardCrossProject: boolean;
	parallelSprints: boolean;
	showEpicAsPanel: boolean;
	isMediaOnCardsEnabled: boolean;
	isInlineCardCreateEnabled: boolean;
	estimationStatisticConfig: {
		currentEstimationStatistic: {
			fieldId: string;
			id: string;
			name: string;
			isEnabled: boolean;
			typeId?: string;
			isValid?: boolean;
			renderer?: string;
		};
	};
	trackingStatisticConfig: {
		currentTrackingStatistic: {
			typeId: string;
			fieldId?: string;
			id: string;
			name: string;
			isValid: boolean;
			isEnabled: boolean;
			renderer: string;
		};
	};
	rapidListConfig: {
		mappedColumns: {
			id: number;
			name: string;
			min: string;
			max: string;
			mappedStatuses: {
				id: string;
				name: string;
				iconUrl: string;
				isInitial: boolean;
				isResolutionDone: boolean;
				isPresentInWorkflow?: boolean;
				statusCategory: {
					id: string;
					key: StatusCategoryKeys;
					colorName: string;
				};
			}[];
			isKanPlanColumn?: boolean;
		}[];
	};
	quickFilterConfig: {
		rapidViewId?: number;
		canEdit?: boolean;
		quickFilters: {
			id: number;
			name: string;
			query: string;
			description?: string;
		}[];
	};
	filterConfig: {
		isOrderedByRank: boolean;
		query: string;
	};
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (rapidViewId: string): ObservableType<BoardConfigResponse> =>
	fetchJson$(`/rest/greenhopper/3/xboard/config?boardId=${rapidViewId}`);
